import { COMEIN_URL } from './host';

const common = {
	// 通用接口
	phpUrl: COMEIN_URL + '/index.php',
	// 地区区号
	areaCode: 'json_tools_areacodelistformat',

	// 接口异常-获取滑块
	errReqCaptcha: 'comein_waf_captcha',
	// 接口异常-完成行为验证
	errReqAllow: 'comein_waf_toAllowList'
};

/* ***************直播厅*************** */
const liveroom = {
	// 页面点击统计 3.6.17后生效
	statistic: 'json_statistic_click',
	// 路演问答--问答列表（全部的）
	listallbyrid: 'json_question_listallbyrid',
	// 检验用户是否正在直播间
	checkLive: 'json_event_check-mic-living',

	listbyuid: 'json_question_listbyuid',

	listbyrid: 'json_question_listbyrid',

	noticepagestatus: 'json_roadshow_noticepagestatus',

	joinliveroom: 'json_roadshow_joinliveroom',

	detail: 'json_roadshow_detail',

	pptpages: 'json_record_pptpages',

	noticepagedocument: 'json_roadshow_noticepagedocument',

	note: 'json_record_note',

	attachmentlist: 'json_roadshow_attachmentlist',

	eventim: 'json_page_eventim',

	getspeakerroadshow: 'json_roadshow_getspeakerroadshow',

	answer: 'json_question_answer',

	questioncount: 'json_question_questioncount',

	question_new: 'json_question_new',

	question_collection: 'json_question_question-collection',

	subotheruser: 'json_user_subotheruser',

	pastroadshow: 'json_roadshow_pastroadshow',

	micuserlist: 'json_event_micuserlist',

	memberinfo: 'json_eventmember_memberinfo',

	attachmentpiclist: 'json_roadshow_attachmentpiclist',

	investor_info: 'json_investor_info',

	analystauth_info: 'json_analystauth_info',

	companymgr_info: 'json_companymgr_info',

	certification_check: 'json_auth_certification-check',

	certification_remove: 'json_auth_certification-remove',

	micquit: 'json_event_micquit',

	userstopspeaking: 'json_event_userstopspeaking',

	micapply: 'json_event_micapply',

	istruephone: 'json_user_is-true-phone',

	allowuserspeaking: 'json_event_allowuserspeaking',

	banuserspeaking: 'json_event_banuserspeaking',

	closecamera: 'json_event_closecamera',

	micmute: 'json_event_micmute',

	micmutecancel: 'json_event_micmutecancel',

	micmuteconfirm: 'json_event_micmuteconfirm',

	micmutecancelconfirm: 'json_event_micmutecancelconfirm',

	investtypelist: 'json_user_investtypelist',

	submitverify: 'json_investor_submitverify',

	apply: 'json_meetingactivity_apply',

	meetingactivity_record: 'json_meetingactivity_record',

	meetingactivity_detail: 'json_meetingactivity_detail',

	contacts_detail: 'json_contacts_detail',

	contacts_search: 'json_contacts_search',

	cardrecog: 'json_user_cardrecog',

	paystatus: 'json_pay_paystatus',

	order_class: 'json_order_class',

	order_research: 'json_order_research',

	order_roadshow: 'json_order_roadshow',

	pay_pc: 'json_pay_pc',

	referrallinkinfo: 'json_popularize_referrallinkinfo',

	specialinfo: 'json_popularize_specialinfo',

	watchrecord: 'json_roadshow_watchrecord',

	changeemail: 'json_account_change-email',

	statistic_roadshow: 'json_statistic_roadshow',

	agoraPush: 'json_agora_push',

	sign: 'json_roadshow_sign',

	listbyuserinvesttype: 'json_investor_list-by-user-invest-type',
	//白噪音水印
	securityWatermark: 'json_security_watermark',
	// 收藏关注
	attentionevent: 'json_event_attentionevent',
	// 等候室轮询获取进入直播厅许可
	prepareResult: 'json_waitingroom_prepare-result',
	// 用户手动点击离开等候室
	userLeave: 'json_waitingroom_user-leave',
	// 预约路演
	appointment: 'json_roadshow_appointment',
	// 投资公司用户类型按名称匹配
	companyTypeCheck: 'json_investor_company-type-check',

	watermark: 'json_security_watermark',

	getbykey: 'json_property_getbykey',

	// 声源设置
	setLang: 'json_rtasr_setlanguage',
	// 历史字幕
	subtitleList: 'json_rtasr_list',
	// 高延时字幕
	liveSubtitle: 'json_rtasr_getordermessage',
	// 上报app后台状态
	userAppStatus: 'json_app_status',
	// 时间段历史字幕
	subtitleListByTime: 'json_rtasr_list-by-time',

	// 获取频道列表
	channellist: 'json_roadshow_get-trans-channels',

	// 检验权益
	checkBenefit: 'json_membership_check-uid-benefit',
	// 订阅字幕
	subtitleSubscription: 'json_rtasr_subscription',

	// tab
	tabList: 'json_roadshow_tab-list',

	// 路演关联研报
	research_list: 'json_roadshow-research_list'
};
/* ***************自助会议*************** */
const selfmeeting = {
	// 获取参会活动申请信息
	getSelfHelpMeetEnroll: 'json_self_get-self-help-meet-enroll',
	// 申请参会报名配置选项列表
	listSelfHelpMeetEnrollConfig: 'json_self_list-self-help-meet-enroll-config',
	// 提交参会活动申请信息
	submitSelfHelpMeetEnroll: 'json_self_submit-self-help-meet-enroll',
	// 加入日程
	addSchedule: 'json_self_add-meet-schedule'
};

const column = {
	// 获取专栏购买的商品列表
	paylist: 'json_column_paylist'
};

const member = {
	// 提交用户基本信息（第一步）
	userinfoput: 'json_suitability_userinfoput',
	// 提交证明材料
	certificatefilecommit: 'json_suitability_certificatefilecommit',
	// 适当性问答提交
	answersubmit: 'json_suitability_answersubmit',
	// 获取人脸识别结果（第一步）
	getkycresult: 'json_suitability_getkycresult',
	// 获取人脸参数
	getfaceinfo: 'json_suitability_getfaceinfo',

	getsignurl: 'json_suitability_getsignurl',

	// 确认节点流程
	confirmFlow: 'json_suitability_confirm-flow',
	// 获取适当性流程流动节点
	getflow: 'json_suitability_getflow',

	// 查询用户企业列表
	userList: 'json_identity_query-user-org',
	// 查询用户企业列表(包含个人信息)
	userListInclude: 'json_identity_query-user-identity',
	// 获取用户身份及邀请通知信息列表(包含个人信息)
	userListIdentityAndInvite: 'json_identity_query-user-identity-and-invite',
	// 判断是否需要进入切换账号页面
	checkIdentityAndInvite: 'json_identity_check-user-identity-and-invite',
	// 邀请通知信息列表立即加入
	joinByInvitationNotification: 'json_identity_join-by-invitation-notification',
	// 邀请通知信息列表不再提示
	ignoreInvitationNotification: 'json_brm_ignore-invitation-notification',
	// 邀请通知在APP打开验证是否是同一用户
	identityCheckPhone: 'json_identity_check-phone',
	// 切换用户登录身份
	switchIdentity: 'json_identity_change-user-identity',

	// 退出企业
	exitInvest: 'json_identity_exit-org',
	// 加入企业
	joinInvest: 'json_identity_join-org',
	// 校验邀请链接
	checkInviteUrl: 'json_brm_check-invite-url',
	// 根据手机号判断用户是否注册
	registerCheck: 'json_user_register-check',
	// 加入 | 退出企业发送短信验证码
	phoneauth: 'json_user_getphoneauth',
	// 校验邀请码是否有效
	checkInvitationCode: 'json_brm_check-invitationcode',

	// 初始化机构意向用户申请信息
	attentionUserInstitutionInit: 'json_attention-user-institution_init',
	// 机构意向用户申请
	attentionUserInstitutionApply: 'json_attention-user-institution_apply'
};

// 日程管理
const schedule = {
	// 日程详情
	detail: 'json_dateschedule_detail'
};

const login = {
	// 免登录 通过 uc 与 userinfo换取登录信息
	orgchannellogin: 'json_user_orgchannellogin',
	// 根据token查询用户缓存信息
	userquery: 'json_user_query',
	// webirm 扫码登录
	scan: COMEIN_URL + '/irmuser/open/irm/user/qrCodeLogin'
};

const roadshow = {
	// 参会申请-白名单引导页信息
	whitelistDetail: 'json_meetingactivity_whitelist-detail',
	// 获取BRM路演限制举手提问配置
	restrictQuestionConfig: 'json_roadshow_restrict-question-config',
	// 校验用户是否有外呼报名的权限
	callout_check: 'json_callout_check',
	// 用户外呼报名选择
	callout_select: 'json_callout_select',
	// 查询企业与主题标签
	summaryTags: 'json_summary_list-summary-tags',
	// 查询标签对应的统计数据
	summarysts: 'json_summary_summary-tag-sts',
	// 查询企业标签对应的基本数据
	stockInfo: 'json_summary_summary-tag-stock-info',
	// 路演列表数据
	roadshowList: 'json_roadshow_summary-tag',
	//同意用户协议
	userAgreement: 'json_user_agreement',
	// 文本关键词识别
	textKeywordRecognize: 'json_text_keyword-recognize',
	// 获取关联专题信息
	relativeTopic: 'json_relative-topic_info',
	// 系列专题路演列表
	seriesTopicRoadshow: 'json_roadshow-list_series-topic',
	// 一键预约该专题下所有路演
	appointmentSeriesRoadshows: 'json_series-topic_appointment-roadshows'
};

const ai = {
	// 获取文档AI纪要状态
	getDocSummaryStatus: 'json_ai-doc-summary_get-status',
	// 文档AI纪要详情
	getDocSummaryDetail: 'json_ai-doc-summary_detail',
	summaryInfo: 'json_summary_summary-info',
	summaryInfoNorid: 'json_summary_summary-info-include-no-rid',
	summaryConferenceInfo: 'json_summary_summary-conference-info',
	aiSummaryMemberList: 'json_summary_ai-summary-roles',
	aiSummaryEmotions: 'json_summary_ai-summary-emotions',
	aiSummaryGetSummaryList: 'json_summary_ai-summary-content',
	summaryAiQa: 'json_summary_ai-qa',
	summaryAiQaList: 'json_summary_ai-qa-list',
	summaryAiChapterList: 'json_summary_list-ai-chapter-road',
	summaryAiChapterListBySummary: 'json_summary_list-ai-chapter-summary',
	summaryAiChapterSummary: 'json_summary_ai-chapter-summary',
	summaryGetMemberList: 'json_summary_host-guest-list',
	aiSummaryCommonQuestion: 'json_summary_ai-common-question',
	summaryKeywordList: 'json_summary_summary-key-word-list',
	aiSummaryGetContentList: 'json_summary_ai-summary-content-list',
	summaryGetContentList: 'json_summary_summary-content-list',
	summaryGetSpeakerList: 'json_summary_summary-speaker-list',
	getSummaryByRid: 'json_roadshow_query-summary-by-roadshowid',
	attentionSummary: 'json_summary_attention-summary',
	points: 'json_summary_query-summary-points',
	// 要点总结溯源
	pointsTrace: 'json_summary_query-summary-points-trace',
	// AI纪要指标数据
	datalist: 'json_summary_query-summary-index-list',
	pptImages: 'json_summary_query-summary-ppt-images',
	// AI纪要文档摘要
	docSummary: 'json_summary_query-summary-word-list'
};

const subscription = {
	usersublist: 'json_subscription_user-sublist'
};
const search = {
	// 联想词搜索
	associativeWord: 'json_hotsearch_associative-word'
};

const i18n = {
	// 批量获取字典数据
	batchGetDict: 'json_content-i18n_batch-get-dict'
};

const membership = {
	getCustomerNumber: 'json_membership_customer-number'
};

const organization = {
	getData: 'json_organization_info-by-orgid'
};

const newLinkEnterprise = {
	checkInviteUrl: 'json_brm_get-org-by-invitecode',
	joinInvest: 'json_identity_join-by-company-url',
	submit: 'json_identity_commit-apply'
};

const stock = {
	//获取个股每日交易数据
	queryKline: 'json_stock_k-line',
	//个股详情
	queryStockDetail: 'json_stock_stock-detail',
	queryStockAttention: 'json_subscription_stock-substatus',
	//获取个股财务指标
	queryFinanceDetail: 'json_stock_query-finance-index-detail',
	querySummaryList: 'json_stock_summary-list',
	queryQAList: 'json_stock_qa-list',
	queryAnnouncementList: 'json_stock_announcement-list',
	queryAnnouncementClassif: 'json_stock_announcement-classif',
	queryImportAnnouncementList: 'json_stock_announcement-import',

	queryPerformanceRoadshow: 'json_brm-roadshow_performance-roadshow',
	queryCompanyRoadshow: 'json_brm-roadshow_company-roadshow',

	subscriptStock: 'json_subscription_substock-operate'
};

const research = {
	researchActivityList: 'json_research_activity-list',
	researchDetail: 'json_research_activity-detail'
};

export default {
	common,
	liveroom,
	member,
	selfmeeting,
	column,
	roadshow,
	schedule,
	login,
	ai,
	subscription,
	search,
	i18n,
	membership,
	organization,
	newLinkEnterprise,
	stock,
	research
};
